import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withAuctionCore } from 'agent';
import useReports from 'hooks/useReports';
import { observer } from 'mobx-react-lite';

import CalculateScoreColor from 'components/utils/scoreHelpers';

import { CircularProgressbar } from 'react-circular-progressbar';
import 'assets/circularslider.css';

import {
  Container,
  ScoreWrapper,
  TMUWrapper, MileageInput,
  ScoreCircleWrapper,
  ScoreCircle,
  ScoreCircleText,
  MileageWrapper,
  MileageCharacters,
  MileageItem,
  TMURow,
  MileageLabel, TMULabel, MileageOuterWrapper,
} from './styles';
import useStores from '../../hooks/useStore';
import { CheckWrapper } from '../../routes/Search/styles';

const Mileage = (m) => {
  console.log(m);
  if (m.toString().toLowerCase() === 'NaN') {
    return ['T', 'M', 'U'];
  }

  return (`\xa0\xa0\xa0\xa0\xa0${m}`).slice(-6).toString()
    .split('');
};

const ConditionScale = observer(({ auctioncore }) => {
  const { UIStore } = useStores();
  const { setReports } = useReports(auctioncore);
  const {
    condition,
    conditionScore,
    setProperty,
    mileage,
    setLoading,
    setActiveTab,
    vehicleCategory,
  } = UIStore;

  const [editMileage, setEditMileage] = useState(false);
  const [newMileage, _setNewMileage] = useState(mileage);

  const mileageRef = useRef();
  const currentMileageRef = useRef(mileage);
  const newMileageRef = useRef(newMileage);

  const setCurrentMileage = (data) => {
    currentMileageRef.current = data;
    setProperty('mileage', data);
  };

  const setNewMileage = (data) => {
    newMileageRef.current = data;
    _setNewMileage(data);
  };

  const TMUToggle = (value) => {
    if (value.target.checked) {
      setProperty('mileage', 'TMU');
      _setNewMileage('TMU');
      return;
    }

    setProperty('mileage', currentMileageRef.current);
    _setNewMileage(currentMileageRef.current);
  };

  const validateMileage = (e) => {
    setNewMileage(e.target.value.toUpperCase());
    return;
    if (!e.target.value) {
      return;
    }

    const re = /^[0-9\b]+$/;

    if (e.target.value === '' || !e.target.value) {
      setNewMileage(e.target.value);
      return;
    }

    // if value is not blank, then test the regex
    if (e.target.value === '' || re.test(e.target.value)) {
      setNewMileage(parseInt(e.target.value));
    }
  };

  const handleClickOutside = async (event) => {
    try {
      if (mileageRef && !mileageRef.current.contains(event.target)) {
        if (newMileageRef.current !== currentMileageRef.current) {
          const re = /^[0-9\b]+$/;

          if (newMileageRef.current.toUpperCase() === 'TMU'
              || newMileageRef.current.toUpperCase() === 'OHV'
              || newMileageRef.current === '0'
              || re.test(newMileageRef.current)) {
            setLoading(true);
            setCurrentMileage(newMileageRef.current);
            await setReports(condition, false, true, false, newMileageRef.current);
            setLoading(false);
          }
        }
        setEditMileage(false);
      }

      if (mileageRef.current.contains(event.target) && !editMileage) {
        setEditMileage(true);
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const handleMileageChange = async () => {
    if (newMileageRef.current !== currentMileageRef.current) {
      const re = /^[0-9\b]+$/;

      if (newMileageRef.current.toUpperCase() === 'TMU'
          || newMileageRef.current === '0'
          || newMileageRef.current.toUpperCase() === 'OHV'
          || re.test(newMileageRef.current)) {
        setLoading(true);
        setCurrentMileage(newMileageRef.current);

        await setReports(condition, false, true, false, newMileageRef.current);
        setLoading(false);
      }
    }
    setEditMileage(false);
  };

  const OHVToggle = async (value) => {
    if (value.target.checked) {
      setProperty('mileage', 'OHV');
      _setNewMileage('OHV');
      setLoading(true);
      await setReports(condition, false, true, false, 'OHV');
      setLoading(false);
      return;
    }

    setProperty('mileage', currentMileageRef.current === 'OHV' ? 500 : currentMileageRef.current);
    _setNewMileage(currentMileageRef.current === 'OHV' ? 500 : currentMileageRef.current);
    setLoading(true);
    await setReports(condition, false, true, false, currentMileageRef.current === 'OHV' ? '500' : currentMileageRef.current);
    setLoading(false);

    // if (value.target.checked) {
    //   setProperty('mileage', 'OHV');
    //   _setNewMileage('OHV');
    //   setNewMileage('OHV');
    //   handleMileageChange();
    //   return;
    // }
    //
    // console.log('OHV', currentMileageRef.current)
    // setProperty('mileage', 1000);
    // _setNewMileage(currentMileageRef.current);
    // setNewMileage(mileageRef.current);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    document.addEventListener('keypress', async (e) => {
      if (e.key === 'Enter') {
        await handleMileageChange();
      }
    });
  }, []);

  const showOHV = () => {
    if (vehicleCategory?.includes('ATV') || vehicleCategory?.includes('MX')) {
      return true;
    }

    return false;

    // switch (vehicleCategory) {
    //   case 'ATV--SIDE BY SIDE':
    //     return true;
    //   case 'ATV--SPORT':
    //     return true;
    //   default:
    //     return false;
    // }
    //
  };

  return (
    <ScoreWrapper color={CalculateScoreColor(conditionScore).color}>
      <Container>
        <ScoreCircleWrapper onClick={() => setActiveTab(0)}>
          <ScoreCircle>
            <CircularProgressbar value={conditionScore} text={conditionScore} />
            <ScoreCircleText>{CalculateScoreColor(conditionScore).value}</ScoreCircleText>
          </ScoreCircle>
        </ScoreCircleWrapper>
        <MileageOuterWrapper>
          <MileageWrapper ref={mileageRef}>
            {editMileage ? (
              <MileageCharacters>
                <MileageInput
                  autoFocus
                  type="text"
                  value={newMileage}
                  onChange={validateMileage}
                />
              </MileageCharacters>
            ) : (
              <MileageCharacters>
                {Mileage(mileage).map((item, i) => <MileageItem key={i}>{item}</MileageItem>)}
              </MileageCharacters>
            )}
            <MileageLabel>Mileage</MileageLabel>
          </MileageWrapper>
          <TMUWrapper>
            <TMURow>
              <TMULabel>TMU</TMULabel>
              <input type="checkbox" onClick={TMUToggle} checked={mileage === 'TMU'} />
            </TMURow>
            {showOHV() && (
            <TMURow>
              <TMULabel>OHV</TMULabel>
              <input type="checkbox" onClick={OHVToggle} checked={mileage === 'OHV'} />
            </TMURow>
            )}
          </TMUWrapper>
        </MileageOuterWrapper>
      </Container>

    </ScoreWrapper>
  );
});

ConditionScale.propTypes = {
  score: PropTypes.string,
  mileage: PropTypes.string,
};

ConditionScale.defaultProps = {
  score: null,
  mileage: 'TMU',
};

export default withAuctionCore(ConditionScale);
